import { useTryDemoMutation } from "@/features/auth/api/tryDemo";
import { TryDemoScreen } from "@/features/auth/screens/TryDemoScreen";
import { createFileRoute } from "@tanstack/react-router";

const Demo = () => {
    const { mutate: tryDemo, isPending } = useTryDemoMutation();
    return (
        <TryDemoScreen
            pending={isPending}
            onTryClinician={() => tryDemo("clinician")}
            onTryPatient={() => tryDemo("patient")}
        />
    );
};

export const Route = createFileRoute("/_auth/try-demo")({
    component: Demo,
});
